import React from 'react';


import { observer, inject } from "mobx-react";
import { Input, InputFile, SelectInput, Collapsible, DatePicker, SingleSwitch,InputValidation, Table, SingleCheckbox ,Chips, Accordion, Spinner, Pagination  } from '@sogei/react-web-components-catalog'
import TiTroviIn from '../widgets/titroviin';
import { breadcrumbRicevutePegno, breadcrumbTrasmissionePegno } from '../../assets/breadcrumb';
import i18next from 'i18next';
import { Formik } from 'formik';
import * as Yup from 'yup'
import { AppButton } from '../commons/button';
import { decodeTipologica, scrollToTop } from '../commons/uiUtils';
import { regExpDate, regExpOnlyNumbers, regExpRepertorioRaccolta } from '../../assets/utils/regexp';
import {SceltaTipoInvio, defaultTipoInvio} from '../trasmissione/tipoInvio';
import {SceltaRicercaAvvisi, defaultRicercaAvvisi} from '../trasmissione/sceltaRicercaAvvisi';
import {SelectConservatorie} from '../commons/selectConservatorie';
import { SelectAnni } from '../commons/selectAnni';
import { isFromCancellazioniIpoteca, isFromElenchi } from '../../assets/utils/queryParams';
import { SelectTipoCCI } from '../commons/selectTipoCCI';
import { SelectStatoProt } from '../commons/selectStatoCI';





@inject("rootStore")
@observer
class DatiRicerca extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
          
          
      }
        
        this.tipologicaStore = props.rootStore.tipologicaStore;
        this.ricevuteStore = props.rootStore.ricevuteStore;
        this.qualificheStore = props.rootStore.qualificheStore;
        this.formikRef = React.createRef();
        this.onSubmit = this.onSubmit.bind(this);
        this.validationSchemaElenchi = Yup.object({
          anno: Yup.mixed().required(i18next.t("VALIDATION_FIELD_REQUIRED",{nomeCampo: i18next.t("ANNO")}))
        })
        this.validationSchema = Yup.object({
         
          dataA: Yup.mixed().test(i18next.t("VALIDATION_DATE_INVALID",{nomeCampo: i18next.t("AL")}),i18next.t("VALIDATION_DATE_INVALID",{nomeCampo: i18next.t("AL")}),(value)=> {
            if(!value) {
              return true;
            }
            return regExpDate(value);
          }),
          dataDa: Yup.mixed().test(i18next.t("VALIDATION_DATE_INVALID",{nomeCampo: i18next.t("DAL")}),i18next.t("VALIDATION_DATE_INVALID",{nomeCampo: i18next.t("DAL")}),(value)=> {
            if(!value) {
              return true;
            }
            return regExpDate(value);
          })
          .test('test_dataDa_DataA',"'Data invio 'Dal' non può essere maggiore di Data invio 'Al'",

          
      function(value) {
        if (value && this.parent.dataA ) {           
            var date_components = value.split("/");
            var day = date_components[0];
            var month = date_components[1];
            var year = date_components[2];
            const dataDa_ = new Date(year, month - 1, day);   

            var date_componentsDataA = this.parent.dataA.split("/");
        
            var dayDataA = date_componentsDataA[0];
            var monthDataA = date_componentsDataA[1];
            var yearDataA = date_componentsDataA[2];
            const dataA_ = new Date(yearDataA, monthDataA - 1, dayDataA);  
            //console.log('dataA_'+dataA_+" - dataDa_ "+dataDa_)
            return (dataDa_ <= dataA_);
        }else return true;    
      }),
     

          idPraticaDa: Yup.mixed().test(i18next.t("VALIDATION_CODICE_INVIO_INVALID",{nomeCampo: i18next.t("DA")}),i18next.t("VALIDATION_CODICE_INVIO_INVALID",{nomeCampo: i18next.t("DA")}),(value)=> {
            if(!value) {
              return true;
            }
            if(value.length > 16){
              return false;
            }
            return regExpOnlyNumbers(value);
          }),
          idPraticaA: Yup.mixed().test(i18next.t("VALIDATION_CODICE_INVIO_INVALID",{nomeCampo: i18next.t("A")}),i18next.t("VALIDATION_CODICE_INVIO_INVALID",{nomeCampo: i18next.t("A")}),(value)=> {
            if(!value) {
              return true;
            }
            if(value.length > 16){
              return false;
            }
            return regExpOnlyNumbers(value);
          }),

          repertorioDa: Yup.mixed().test(i18next.t("VALIDATION_REPERTORIO_RACCOLTA",{nomeCampo: i18next.t("DA")}),i18next.t("VALIDATION_REPERTORIO_RACCOLTA",{nomeCampo: i18next.t("DA")}),(value)=> {
            if(!value) {
              return true;
            }
            return regExpRepertorioRaccolta(value);
            
          }),
             
          repertorioA: Yup.mixed().test(i18next.t("VALIDATION_REPERTORIO_RACCOLTA",{nomeCampo: i18next.t("A")}),i18next.t("VALIDATION_REPERTORIO_RACCOLTA",{nomeCampo: i18next.t("A")}),(value)=> {
            if(!value) {
              return true;
            }
           
            return regExpRepertorioRaccolta(value);
          }),



          customValidation: Yup.mixed().test(props.tipoPratica === 'UN'? i18next.t("VALIDATION_ONE_FIELD_MANDATORY_2"):i18next.t("VALIDATION_ONE_FIELD_MANDATORY"), props.tipoPratica === 'UN'? i18next.t("VALIDATION_ONE_FIELD_MANDATORY_2"):i18next.t("VALIDATION_ONE_FIELD_MANDATORY"), (value) => {
            if(!this.formikRef.state.values.dataDa && !this.formikRef.state.values.idPraticaDa && !this.formikRef.state.values.repertorioDa) {
              return false;
            }
            return true;
          })
        });
        this.onSubmit = this.onSubmit.bind(this);
        this.navigateToDettaglio = this.navigateToDettaglio.bind(this);
    }  

    componentDidMount() {
      this.tipologicaStore.fetchStatoInvio(this.props.tipoPratica);
      this.tipologicaStore.fetchStatoProt(this.props.tipoPratica);
      this.tipologicaStore.fetchTipoCCI(this.props.tipoPratica);
      
    }
  
    onAvvisiChange() {
      
  }


    componentWillUnmount() { 

    }

  
    onSubmit(values,actions) {
      let params = {};
      let ricercaByDate = $("#idAccordionDatiRicerca-0")[0];
      let ricercaByIdPratica = $("#idAccordionDatiRicerca-1")[0];
      let ricercaByRepertorio = $("#idAccordionDatiRicerca-2")[0];
      let isVisibleRicercaByDate = ricercaByDate?ricercaByDate.classList.contains('show'):false;
      if(isVisibleRicercaByDate) {
        actions.setFieldValue('openIndex', 0, false);
        params.openIndex = 0;
      }

      let isVisibleRicercaByIdPratica = ricercaByIdPratica?ricercaByIdPratica.classList.contains('show'):false;
      if(isVisibleRicercaByIdPratica) {
        actions.setFieldValue('openIndex', 1, false);
        params.openIndex = 1;
      }

      let isVisibleRicercaByRepertorio = ricercaByRepertorio?ricercaByRepertorio.classList.contains('show'):false;
      if(isVisibleRicercaByRepertorio) {
        actions.setFieldValue('openIndex',2 , false);
        params.openIndex = 2 ;
      }

      if(isVisibleRicercaByDate && !values.dataDa) {
        actions.setFieldValue('idPraticaA','',true);
        actions.setFieldValue('idPraticaDa','',true);
        actions.setFieldValue('repertorioA','',true);
        actions.setFieldValue('repertorioDa','',true);
        return;
      }
      if(isVisibleRicercaByIdPratica && !values.idPraticaDa) {
        actions.setFieldValue('dataA','',true);
        actions.setFieldValue('dataDa','',true);
        actions.setFieldValue('repertorioA','',true);
        actions.setFieldValue('repertorioDa','',true);
        return;
      }
      if(isVisibleRicercaByRepertorio && !values.repertorioDa) {
        actions.setFieldValue('dataA','',true);
        actions.setFieldValue('dataDa','',true);
        actions.setFieldValue('idPraticaA','',true);
        actions.setFieldValue('idPraticaDa','',true);
        return;
      }

      if(values.dataDa) {
        params.dataDa = values.dataDa;
        params.dataA = values.dataA;
        if(!params.dataA) {
          params.dataA = params.dataDa;
          actions.setFieldValue('dataA',values.dataDa,false);
        }
      }
      if(values.idPraticaDa) {
        params.idPraticaDa = values.idPraticaDa;
        params.idPraticaA = values.idPraticaA;
        if(!params.idPraticaA) {
          params.idPraticaA = params.idPraticaDa
          actions.setFieldValue('idPraticaA',values.idPraticaDa,false);
        }
      }
      if(values.repertorioDa) {
        params.primoNumRepertorioDa = values.repertorioDa.split('/')[0];
        params.secNumRepertorioDa = values.repertorioDa.split('/')[1];

       
        if(!values.repertorioA) {
          params.primoNumRepertorioA = values.repertorioDa.split('/')[0];
          params.secNumRepertorioA = values.repertorioDa.split('/')[1];
          actions.setFieldValue('repertorioA',values.repertorioDa,false);
        }
        else{
          params.primoNumRepertorioA = values.repertorioA.split('/')[0];
          params.secNumRepertorioA = values.repertorioA.split('/')[1];
        
        }
      } 
        //console.log(values.tipoInvio)
        if(values.tipoInvio)
        {
          params.flagProva = values.tipoInvio;
          
        }
       
      if(true){  
        params.flagAvvisi = values.flagAvvisi?'1':'0'
      }
      params.tipoPratica = this.props.tipoPratica;
      params.codiceUffPPII = values.conservatoria ? values.conservatoria : undefined;
      params.statoPratica = values.statoPratica ? values.statoPratica : undefined;
      params.statoCancellazione = values.statoCancellazione ? values.statoCancellazione : undefined;
      params.tipoCancellazione = values.tipoCancellazione ? values.tipoCancellazione : undefined;
      this.setState({pagination:this.initialPagination})
      if(this.props.isFromElenchi) {
        console.log(values.anno)
        params.anno = values.anno;
      }
      console.log(this.props.tipoPratica)
      this.ricevuteStore.fetchRicevute(params,this.props.tipoPratica,this.props.isFromElenchi);
      
    }

    navigateToDettaglio(ricevuta) {
      this.ricevuteStore.loadAndNavigateToSecondoLivello(this.formikRef.state.values, ricevuta);
    }
 
  render() {
    const filtriRicerca = this.ricevuteStore.filtriRicerca;
      const listaStatiInvio = this.tipologicaStore.statoInvio; 
      //console.log("lista" + listaStatiInvio)

      const path = window.location.href.pathname;
      
      const opzioniRicerca = props => { 

        const ricercaPerData = { title: i18next.t("DATA_INVIO"),  body: <>
              <div className='row'>
                <div className='col-sm-12 col-md-6 col-xl-4'>
                  <DatePicker
                    id="dataDa"
                    name="dataDa"
                    value={props.values.dataDa}
                    event={{
                        onChange: (data) => {
                            props.setFieldValue('dataDa',data)
                            props.setFieldValue('idPraticaDa','');
                            props.setFieldValue('idPraticaA','');
                            props.setFieldValue('repertorioDa','');
                            props.setFieldValue('repertorioA','');
                        }
                    }}   
                    error={props.touched.dataDa && props.errors.dataDa}
                    extraProps={{}}
                    inputClass={[]}
                    label={i18next.t('DAL')}
                  ></DatePicker>
                </div>
                <div className='col-sm-12 col-md-6 col-xl-4'>
                  <DatePicker
                    id="dataA"
                    name="dataA"
                    value={props.values.dataA}
                    event={{
                        onChange: (data) => {
                            props.setFieldValue('dataA',data)
                            props.setFieldValue('idPraticaDa','');
                            props.setFieldValue('idPraticaA','');
                            props.setFieldValue('repertorioDa','');
                            props.setFieldValue('repertorioA','');
                        }
                    }}   
                    error={props.touched.dataA && props.errors.dataA}
                    extraProps={{}}
                    inputClass={[]}
                    label={i18next.t('AL')}
                  ></DatePicker>
                </div>
              </div>
        </> }
        const ricercaPerIdPratica =
         { title: i18next.t("CODICE_INVIO"), body: <>
    <div className='row'>
      <div className='col-sm-12 col-md-6 col-xl-4'>
        <Input
          id="idPraticaDa"
          name="idPraticaDa"
          value={props.values.idPraticaDa}
          type="text"
          dimension="lg"
          label={i18next.t("DA")}
          error={props.touched.idPraticaDa && props.errors.idPraticaDa}
          labelClass={[]}
          inputClass={[]}
          event={{ onChange:  (event) => {
            props.handleChange(event);
            props.setFieldValue('dataDa','');
            props.setFieldValue('dataA','');
            props.setFieldValue('repertorioDa','');
            props.setFieldValue('repertorioA','');
          } }}
          extraProps={{}}
        />
      </div>
      <div className='col-sm-12 col-md-6 col-xl-4'>
        <Input
          id="idPraticaA"
          name="idPraticaA"
          value={props.values.idPraticaA}
          type="text"
          dimension="lg"
          label={i18next.t("A")}
          error={props.touched.idPraticaA && props.errors.idPraticaA}
          labelClass={[]}
          inputClass={[]}
          event={{ onChange:  (event) => {
            props.handleChange(event);
            props.setFieldValue('dataDa','');
            props.setFieldValue('dataA','');
            props.setFieldValue('repertorioDa','');
            props.setFieldValue('repertorioA','');
          } }}
          extraProps={{}}
        />
      </div>
    </div>
  </> }

  const ricercaPerRepertorio= { title: i18next.t("REPERTORIO"),body: <> 
    <div className='row align-items-center'>
  <span className='sr-only'> {i18next.t("REPERTORIO")} </span>
    <div className='col-sm-12 col-md-2 col-xl-2'>
      <Input
        id="repertorioDa"
        name="repertorioDa"
        value={props.values.repertorioDa}
        type="text"
        dimension="lg"
        label= {[<span className='sr-only' key='A'>{i18next.t('REPERTORIO')} </span>, i18next.t('DAL')]  }
        error={props.touched.repertorioDa && props.errors.repertorioDa}
        labelClass={[]}
        inputClass={[]}
        
        event={{ onChange:  (event) => {
          props.handleChange(event);
          props.setFieldValue('idPraticaDa','');
          props.setFieldValue('idPraticaA','');
          props.setFieldValue('dataDa','');
          props.setFieldValue('dataA','');
        } }}
        extraProps={{placeholder:i18next.t("PLACEHOLDER_REPERTORIO_RACCOLTA")}}
      />
    </div>
   
    <div className='col-sm-12 col-md-2 col-xl-2'>
    <span className='sr-only'> {i18next.t("REPERTORIO")} </span>
      <Input
        id="repertorioA"
        name="repertorioA"
        value={props.values.repertorioA}
        type="text"
        dimension="lg"
        label= {[<span className='sr-only' key='B'>{i18next.t('REPERTORIO')} </span>, i18next.t('A')]  }
        error={props.touched.repertorioA && props.errors.repertorioA}
        labelClass={[]}
        inputClass={[]}
        event={{ onChange:  (event) => {
          props.handleChange(event);
          props.setFieldValue('idPraticaDa','');
          props.setFieldValue('idPraticaA','');
          props.setFieldValue('dataDa','');
          props.setFieldValue('dataA','');

        } }}
        extraProps={{placeholder:i18next.t("PLACEHOLDER_REPERTORIO_RACCOLTA")}}
      />
    </div>
  </div>
</> }


  switch (this.props.tipoPratica) {
    case 'UN':
      return [ricercaPerData,ricercaPerIdPratica,ricercaPerRepertorio]
    case 'CI':{
      if(this.props.isFromElenchi){
      return []
    }
    else{
      return [ricercaPerData,ricercaPerIdPratica]
    }
    }
    default:
      return [ricercaPerData,ricercaPerIdPratica]
      
  }



        }



   


     

    

 

    const formDati = (props) => {
      this.values = props.values;
      //console.log("this.values: ", JSON.stringify(this.values));
      const validation = (touched, errors) => {
        if((touched.dataDa && errors.dataDa)
        || (touched.dataA && errors.dataA)
        || (touched.idPraticaDa && errors.idPraticaDa)
        || (touched.idPraticaA && errors.idPraticaA)
        || (touched.repertorioDa && errors.repertorioDa)
        || (touched.repertorioA && errors.repertorioA)
        || (touched.anno && errors.anno)
        || (touched.customValidation && errors.customValidation)
            ) {
                return <>
                    <InputValidation show={touched.dataDa && errors.dataDa} error={errors.dataDa} />
                    <InputValidation show={touched.dataA && errors.dataA} error={errors.dataA} />
                    <InputValidation show={touched.idPraticaDa && errors.idPraticaDa} error={errors.idPraticaDa} />
                    <InputValidation show={touched.idPraticaA && errors.idPraticaA} error={errors.idPraticaA} />
                    <InputValidation show={touched.repertorioDa && errors.repertorioDa} error={errors.repertorioDa} />
                    <InputValidation show={touched.repertorioA && errors.repertorioA} error={errors.repertorioA} />
                    <InputValidation show={touched.anno && errors.anno} error={errors.anno} />
                    <InputValidation show={touched.customValidation && errors.customValidation} error={errors.customValidation} />
                </>
        }
        return null
    }
      
      //console.log("props: ", JSON.stringify(props));
      return (
     <Formik
        ref={(ref) => this.formikRef = ref}
        initialValues={{
          dataDa: filtriRicerca ? filtriRicerca.dataDa : '',
          dataA: filtriRicerca ? filtriRicerca.dataA :  '',
         idPraticaDa: filtriRicerca ? filtriRicerca.idPraticaDa :  '',                    
         idPraticaA: filtriRicerca ? filtriRicerca.idPraticaA :  '',
          statoPratica: filtriRicerca ? filtriRicerca.statoPratica :  '',
          customValidation: '',
          flagAvvisi: defaultRicercaAvvisi(this.tipoPratica),
          conservatoria: props.filtriRicerca ? props.filtriRicerca.conservatoria: '',
          tipoInvio : defaultTipoInvio(this.tipoPratica),
          repertorioDa: filtriRicerca ? 
                   
          (filtriRicerca.secNumRepertorioDa?
          (filtriRicerca.primoNumRepertorioDa +"/"+ filtriRicerca.secNumRepertorioDa)
          :filtriRicerca.primoNumRepertorioDa)
          
          :  '',                    
          repertorioA: filtriRicerca ? 
          
          (filtriRicerca.secNumRepertorioA?
          (filtriRicerca.primoNumRepertorioA +"/"+ filtriRicerca.secNumRepertorioA)
          :filtriRicerca.primoNumRepertorioA)
          
          :  '', 

          anno: ''



          //openIndex: filtriRicerca ? filtriRicerca.openIndex :  0,
          //pagination: pagination
        }}
        validationSchema={props.isFromElenchi?this.validationSchemaElenchi:this.validationSchema}
        enableReinitialize={true}
        onSubmit={(values, actions) => {
            this.onSubmit(values,actions);
        }}
      >
        {props => (
          <>
          
            <div className="my-2">
                {validation(props.touched, props.errors)}
            </div>
            <form onSubmit={props.handleSubmit}>
              <Collapsible
                collapsed={false}
                cardType="default"
                title={i18next.t("DATI_RICERCA")}
                body={<>
                  <Accordion
                  openIndex={props.values.openIndex}
                  id="idAccordionDatiRicerca"
                  contentList= {opzioniRicerca(props)}
                  />
                {   !this.props.isFromElenchi ?        
                <div className='row'>
                  <div className='col-sm-12 col-md-6 col-xl-4'>
                    <SelectInput
                        id="statoPratica"
                        name="statoPratica"
                        value={props.values.statoPratica}
                        dimension="lg"
                        label={i18next.t("STATO_INVIO")}
                        firstEmptyOption={true}
                        optionList={listaStatiInvio}
                        error={props.touched.statoPratica && props.errors.statoPratica}
                        inputClass={[]}
                        labelClass={[]}
                        event={{ onChange: props.handleChange }}
                        extraProps={{}}
                    ></SelectInput>
                  </div>
                </div>
                : undefined
                }
               
                          <SelectConservatorie values={props.values}  onChange={props.handleChange} tipoPratica = {this.props.tipoPratica} ></SelectConservatorie>
                          <SceltaTipoInvio values={props.values} onChange={props.handleChange}  tipoPratica = {this.props.tipoPratica} />
                          <SceltaRicercaAvvisi values={props}  tipoPratica = {this.props.tipoPratica} />
                          <SelectAnni  values={props.values} touched = {props.touched} errors = {props.errors} onChange={props.handleChange} tipoPratica = {this.props.tipoPratica} isFromElenchi = {this.props.isFromElenchi}/>
                          <SelectStatoProt  values={props.values} touched = {props.touched} errors = {props.errors} onChange={props.handleChange} tipoPratica = {this.props.tipoPratica} isFromElenchi = {this.props.isFromElenchi}/>
                          <SelectTipoCCI  values={props.values} touched = {props.touched} errors = {props.errors} onChange={props.handleChange} tipoPratica = {this.props.tipoPratica} isFromElenchi = {this.props.isFromElenchi}/>
                         
                         
               
                <div className='row'>
                  <div className='col-sm-12 col-md-6 col-xl-4'>
                      <AppButton id="cercaRicevute" type="submit" titleKey="BUTTON_CERCA" iconLeft="fas fa-search" customClass="mr-2"></AppButton>
                      <AppButton id="ripulisciRicerca" type="reset" titleKey="BUTTON_RIPULISCI" iconLeft="fas fa-eraser" onClick={() => {
                        props.setFieldValue('dataDa','',false);
                        props.setFieldValue('dataA','',false);
                        props.setFieldValue('idPraticaDa','',false);
                        props.setFieldValue('idPraticaA','',false);
                        props.setFieldValue('repertorioDa','',false);
                        props.setFieldValue('repertorioA','',false);
                        props.setFieldValue('statoPratica','',false);
                        props.setFieldValue('anno','',false);
                        props.setFieldValue('customValidation','',false);
                      }}></AppButton>
                  </div>
                </div>
                </>}
                id="idDatiRicerca"
              />
              
            </form>
          </>
        )}
      </Formik>

      )

    }

    return (
        formDati(this.props)

    );
  }

}



//export default SceltaTipoInvio;

export {DatiRicerca};